export enum ScheduleEntryKind {
	PROJECT = "project",
	TYPE = "type",
}
